export const roles_mock = [
  {
    id: 'participant',
    name: 'Участник',
  },
  {
    id: 'orp',
    name: 'Ответственный от ОРП',
  },
  {
    id: 'expert',
    name: 'Эксперт с дополнительными полномочиями',
  },
  {
    id: 'deputy_expert',
    name: 'Заместитель главного эксперта',
  },
  {
    id: 'division_expert',
    name: 'Главный дивизионный эксперт',
  },
  {
    id: 'expert_compatriot',
    name: 'Эксперт-компатриот',
  },
  // TODO: Временно отключено до готовности бэка по задаче 33069
  // {
  //   id: 'deputy_chief_expert',
  //   name: 'Заместитель главного эксперта',
  // },
]
